import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../../../shared/services/product/product.service';
import { LoaderService } from '../../../../core/services/loader/loader.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { ErrorhandlerService } from '../../../../shared/services/errorhandler/errorhandler.service';
import { NotificationService } from '../../../../core/services/notification/notification.service';
import { CustomProductFilterModel } from '../../../../shared/models/product';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../../store-editor/services/common.service';


@Component({
  selector: 'app-warehouse-product-listing',
  templateUrl: './warehouse-product-listing.component.html',
  styleUrls: ['./warehouse-product-listing.component.css']
})
export class WarehouseProductListingComponent implements OnInit {
  customproductList !: any[];
  filterModel !: CustomProductFilterModel;
  pageSize = 10; // No of items to load from server side i.e no of items to take
  initialItemsCount = 0;  // No of items to skip
  throttle = 50;
  scrollDistance = 4;
  searchString: any;
  searchCommission: FormGroup;
  isFullListDisplayed: boolean = false;
  isDisplay = true;
  parentRouteParam !: any;
  scrolling = false;
  IsStoreAdmin: boolean;
  constructor(private productService: ProductService, private loader: LoaderService, private commonservice: CommonService,
    private notificationService: NotificationService,
    private errorhandlerService: ErrorhandlerService, public formBuilder: FormBuilder, private route: Router, private activatedRoute: ActivatedRoute) {
    this.searchCommission = this.formBuilder.group({
      search: ['']
    });
    if (this.activatedRoute.parent) {
      this.activatedRoute.parent.params.subscribe(params => {
        this.parentRouteParam = '';//params['storename'];
      });
    }
  }

  ngOnInit() {
    this.IsStoreAdmin = localStorage.getItem('role') === 'StoreAdmin' || localStorage.getItem('role') === 'StoreOwner' || localStorage.getItem('role') === 'StoreStaffMember';
    this.fn_Initialize();
  }
  fn_Initialize() {
    this.initialItemsCount = 0;
    this.customproductList = [];
    this.filterModel = {
      Skip: this.initialItemsCount,
      Take: this.pageSize,
      searchBy: '',
      UserId: Number(localStorage.getItem('userId'))
    };

    this.fn_getCustomProductList()

  }

  fn_getCustomProductList_Scroll() {
    if (!this.scrolling) {
      this.scrolling = true;
      this.fn_getCustomProductList();
    }
  }

  fn_getCustomProductList() {
      this.loader.lazyLoaderShow();
      this.filterModel.Skip = this.initialItemsCount;
      this.productService.getAllCustomProducts(this.filterModel).subscribe((res: any) => {
        if (res.StatusCode == 200) {
          this.fn_AddLazyLoadedItems(res.Data.ResponseData);
          this.loader.lazyLoaderHide();
        } else if (res.StatusCode === 204 || res.StatusCode === 404) {
          if (this.initialItemsCount <= 0) {
            this.notificationService.error(res.Message, 'Record(s)');
          }
          this.loader.lazyLoaderHide()
        }
        this.scrolling = false;
      }, err => {
        this.scrolling = false;
        this.loader.lazyLoaderHide();
        this.errorhandlerService.handleError(err);
      });
  }

  fn_GetImage(imageName: string) {
    if (imageName != undefined) {
      if (imageName.indexOf('https://stores.inksoft.com') !== -1)
        return imageName;
      else
        return environment.warehouseProductCustomImageFolder + imageName;
    }
   
    
  }

  /** Function to add new lazy loaded items to original items list */
  fn_AddLazyLoadedItems(items: any) {
    if (items !== null && items.length !== 0) {
      for (let i = 0; i < items.length; i++) {
        if (!this.customproductList.find(x => x.ProductID === items.ProductID)) {
          this.initialItemsCount = this.customproductList.push(items[i]);
        }
      }
    }
    if (items.length < this.pageSize) {
      this.isFullListDisplayed = true;
    }
    this.isDisplay = this.initialItemsCount === 0
  }
  fn_searchCommission(form: FormGroup) {
    this.customproductList = [];
    this.isFullListDisplayed = false;
    this.initialItemsCount = 0;
    this.scrolling = false;
    this.filterModel.searchBy = form.controls['search'].value;
    this.fn_getCustomProductList();
  }

  fn_viewProductdetais(productId: string) {
    this.route.navigate(['viewcustomdetail', productId], { relativeTo: this.activatedRoute.parent });
  }

  fn_UpdateCustomProduct(productId: number) {
    this.route.navigate(['store/editcustomproduct/' + productId])
  }

  fn_navigateInventoryPage(productId: number) {
    this.route.navigate(['inventory', productId], { relativeTo: this.activatedRoute.parent });
  }
  fn_deleteCustomizedWareHouseProduct(productid: any) {
    this.loader.show();
    this.productService.deleteWareHouseProduct(Number(productid)).subscribe((res: any) => {
      if (res.StatusCode = 200) {
        this.loader.hide();

        this.notificationService.success("Product succesfully deleted", 'Success');
        this.customproductList = [];
        this.scrolling = false;
        this.isFullListDisplayed = false;
        this.initialItemsCount = 0;
        this.fn_getCustomProductList();
      } else {
        this.loader.hide();
        this.notificationService.error(res.Message, 'Error');
      }
    })
  }
}
